@if (step$ | async; as step) {
  @if (isLoading$ | async) {
    <div class="position-relative">
      <div class="row h-100 m-3">
        <div
          class="col-12 text-center d-flex align-items-center justify-content-center"
        >
          <div class="spinner-border text-primary" role="status">
            <span class="sr-only">{{ 'common.loading' | translate }}</span>
          </div>
        </div>
      </div>
    </div>
  } @else {
    <div class="modal-content m-0">
      <div class="modal-header">
        <p class="mb-0">
          {{
            'pii.details.approve.dialog.title'
              | translate: { fileName: document.fileName }
          }}
        </p>
        <i
          class="fa-light fa-xmark ms-auto cursor-pointer"
          (click)="dismiss()"
        ></i>
      </div>

      <div class="modal-body">
        @if (step === DialogStep.prepareEmail) {
          @if (notificationProfile || TemplateType.Canceled) {
            <div class="mb-3">
              {{
                'pii.details.approve.dialog.prepareEmailDescription'
                  | translate
                    : {
                        profileName:
                          notificationProfile?.name ?? TemplateType.Canceled,
                      }
              }}
            </div>

            @if (
              templateType === TemplateType.NotQualified ||
              templateType === TemplateType.Canceled
            ) {
              <label class="label-primary ps-1">{{
                'pii.details.approve.createCustomEmailNotQualifiedMessage'
                  | translate
              }}</label>
            } @else {
              <form
                class="row form-group"
                [formGroup]="sendEmailForm.form"
                novalidate
              >
                @if (templateType === TemplateType.HighRisk) {
                  <div class="label form-control-label col-12 mb-2">
                    <label class="label-primary ps-1" for="reason">{{
                      'pii.details.approve.dialog.highRiskReason' | translate
                    }}</label>
                    <input
                      class="form-control"
                      formControlName="reason"
                      name="reason"
                      id="reason"
                      type="text"
                      (keydown)="error$.next(null)"
                      [placeholder]="
                        'pii.details.approve.dialog.placeholders.highRiskReason'
                          | translate
                      "
                    />
                  </div>
                }

                <div class="label form-control-label col-12 mb-2">
                  <label class="label-primary ps-1" for="subject">{{
                    'pii.details.approve.mailSubject' | translate
                  }}</label>
                  <input
                    class="form-control"
                    formControlName="subject"
                    name="subject"
                    id="subject"
                    type="text"
                    [placeholder]="
                      'pii.details.approve.dialog.placeholders.emailSubject'
                        | translate
                    "
                  />
                </div>
                <div class="label form-control-label col-12">
                  <label class="label-primary ps-1" for="body">{{
                    'pii.details.approve.dialog.mailBody' | translate
                  }}</label>
                  <textarea
                    rows="10"
                    class="form-control"
                    formControlName="body"
                    name="body"
                    id="body"
                    type="text"
                    [placeholder]="
                      'pii.details.approve.dialog.placeholders.emailBody'
                        | translate
                    "
                  ></textarea>
                </div>
              </form>
              <div class="row">
                <div class="col-12">
                  <app-data-table
                    [configuration]="toDataTableConfiguration"
                  ></app-data-table>
                </div>
              </div>
              <hr />
              <div class="row">
                <div class="col-12">
                  <app-data-table
                    [configuration]="ccDataTableConfiguration"
                  ></app-data-table>
                </div>
              </div>
              <hr />
              <div class="row">
                <div class="col-12">
                  <app-data-table
                    [configuration]="bccDataTableConfiguration"
                  ></app-data-table>
                </div>
              </div>
            }
          } @else {
            <div class="mb-0">
              {{
                'pii.details.approve.dialog.notificationProfilesMissing'
                  | translate
              }}
            </div>
          }
        } @else if (step === DialogStep.previewEmail) {
          <div class="mb-3">
            {{
              'pii.details.approve.dialog.confirmSendingDescription'
                | translate: { profileName: notificationProfile.name }
            }}
          </div>
          <div class="row form-group">
            @if (emailConfig.to.length) {
              <div class="col-12 mb-2">
                <label class="label form-control-label label-primary"
                  >{{
                    'pii.details.approve.dialog.labels.to' | translate
                  }}:</label
                >
                <div>{{ emailConfig.to.join(', ') }}</div>
              </div>
            }

            @if (emailConfig.cc.length) {
              <div class="col-12 mb-2">
                <label class="label form-control-label label-primary"
                  >{{
                    'pii.details.approve.dialog.labels.cc' | translate
                  }}:</label
                >
                <div>{{ emailConfig.cc.join(', ') }}</div>
              </div>
            }

            @if (emailConfig.bcc.length) {
              <div class="col-12 mb-2">
                <label class="label form-control-label label-primary"
                  >{{
                    'pii.details.approve.dialog.labels.bcc' | translate
                  }}:</label
                >
                <div>{{ emailConfig.bcc.join(', ') }}</div>
              </div>
            }

            @if (emailConfig.subject) {
              <div class="col-12 mb-2">
                <label class="label form-control-label label-primary"
                  >{{
                    'pii.details.approve.dialog.labels.subject' | translate
                  }}:</label
                >
                <div>{{ emailConfig.subject }}</div>
              </div>
            }
            @if (emailConfig.body) {
              <div class="col-12 mb-2">
                <label class="label form-control-label label-primary"
                  >{{
                    'pii.details.approve.dialog.labels.body' | translate
                  }}:</label
                >
                <div style="white-space: pre-line">{{ emailConfig.body }}</div>
              </div>
            }
          </div>
        } @else if (step === DialogStep.approveDocument) {
          <div>
            {{
              'pii.details.approve.dialog.confirmApproveMessage'
                | translate: { fileName: document.fileName, kitId: kitId }
            }}
          </div>
        }

        @if (error$ | async; as error) {
          <div class="caption text-danger">
            {{ error }}
          </div>
        }
      </div>

      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-clear me-2"
          [disabled]="isLoading$ | async"
          (click)="cancel(step)"
        >
          @if (step === DialogStep.previewEmail) {
            <span>{{
              'pii.details.approve.dialog.buttons.edit' | translate
            }}</span>
          } @else {
            <span>{{
              'pii.details.approve.dialog.buttons.cancel' | translate
            }}</span>
          }
        </button>

        @if (step === DialogStep.previewEmail) {
          <button
            type="button"
            class="btn btn-primary"
            [disabled]="
              !notificationProfile ||
              (isLoading$ | async) ||
              templateType === TemplateType.NotQualified ||
              templateType === TemplateType.Canceled
            "
            (click)="sendEmails(true)"
          >
            {{ 'pii.details.approve.sendEmail' | translate }}
          </button>
        }

        @if (step === DialogStep.prepareEmail) {
          <button
            type="button"
            class="btn btn-primary"
            [disabled]="
              !notificationProfile ||
              (isLoading$ | async) ||
              templateType === TemplateType.NotQualified ||
              templateType === TemplateType.Canceled
            "
            (click)="previewEmail()"
          >
            {{ 'pii.details.approve.previewEmail' | translate }}
          </button>
        }

        @if (step === DialogStep.approveDocument) {
          <button
            type="button"
            class="btn btn-primary"
            (click)="approveDocument()"
            [disabled]="isLoading$ | async"
          >
            {{ 'pii.details.approve.dialog.buttons.approve' | translate }}
          </button>
        }
      </div>
    </div>
  }
}

<ng-template #loading>
  <div class="pt-1 loading"></div>
</ng-template>
